// extracted by mini-css-extract-plugin
export default {"NicotineInfo":"Ky_rXzJE","Item":"nBMHj50C"};